export const PRODUCT_TYPES = {
    BUNDLE: 'BUNDLE',
    CHATROOM: 'CHATROOM',
    EDITORIAL: 'EDITORIAL',
    FLAGSHIP: 'FLAGSHIP',
    HUB: 'HUB',
    LIVESTREAM: 'LIVESTREAM',
    ORG: 'ORG',
    SCANNER: 'SCANNER',
    NEWSLETTER: 'NEWSLETTER'
}; // ALSO UPDATE Libs\Backend\src\utils\types.ts
export const ROLES = {
    ADMIN: 'admin',
    MODERATOR: 'moderator',
    HOST: 'host',
    EXPERT: 'expert',
    VIP: 'vip',
    BOT: 'bot',
    SUBSCRIBER: 'subscriber'
};
export const ROLE_GROUPS = {
    ALL: [
        ROLES.ADMIN,
        ROLES.MODERATOR,
        ROLES.HOST,
        ROLES.EXPERT,
        ROLES.VIP,
        ROLES.BOT,
        ROLES.SUBSCRIBER
    ],
    STAFF: [ROLES.ADMIN, ROLES.HOST, ROLES.MODERATOR, ROLES.EXPERT],
    MODERATION: [ROLES.ADMIN, ROLES.HOST, ROLES.MODERATOR],
    ADMIN: [ROLES.ADMIN]
};
export const PRODUCT_ACCESS_MODES = {
    FREE: 'FREE',
    SUBSCRIPTION: 'SUBSCRIPTION',
    SUBSCRIPTION_ANY: 'SUBSCRIPTION_ANY',
    SUBSCRIPTION_SUBTYPES: 'SUBSCRIPTION_SUBTYPES'
};
export const PRODUCT_ACCESS_LEVELS = {
    FREE: 'Free',
    STANDARD: `Standard`,
    PRO: `Pro`,
    UNLIMITED: `Unlimited`
};
export const SOCKET_ROOMS = {
    LIVESTREAM: {
        STAFF_PUBLIC_CHAT: 'livestream:staff:public-messages:general',
        PUBLIC_CHAT: 'livestream:public-messages:general',
        QUESTIONS: 'livestream:staff:questions',
        VIEW_COUNT: 'livestream:staff:view-count',
        USER: 'livestream:user:',
        PRODUCT: 'livestream:'
    }
};
//# sourceMappingURL=constants.js.map